module.exports = __webpack_public_path__ + "components/rewards/vista-tours/static/logo-84de45839cfecb6f15892872b5a38e2d.webp";